import { createReducer, on } from '@ngrx/store';

import * as AccessControlActions from './access-control.actions';
import { AccessControlState } from './access-control.model';

export const featureKey = 'access-control';

const initialState: AccessControlState = {
    permissionsLoading: false,
    permissionsLoaded: false,
    permissions: []
};

export const reducer = createReducer(
    initialState,
    on(AccessControlActions.loadPermissions, (state) => ({
        ...state,
        permissionsLoading: true
    })),
    on(AccessControlActions.loadPermissionsSuccess, (state, { permissions }) => ({
        ...state,
        permissionsLoading: false,
        permissionsLoaded: true,
        permissions
    }))
);
